import React from 'react';
import './SectionFooter.css'

const SectionFooter = ({footerText}) => {
  return (
    <div className='row text-center section-footer'>
      <p>{footerText}</p>
    </div>
  )
}

export default SectionFooter;



// WEBPACK FOOTER //
// ./src/components/SectionFooter.js